import freelance from "../assets/freelance.png";
import seo from "../assets/seo.png";
import sitemap from "../assets/sitemap.png";
import { BsCalendar2Week } from "react-icons/bs";
import analyticsLight from "../assets/analytics-light.png";
import analyticsDark from "../assets/analytics-dark.png";
import { useDarkMode } from "../utils/DarkModeContext";
import cms from "../assets/cms.png";
import cookies from "../assets/cookies.png";

import {
  BsCardChecklist,
  BsCardHeading,
  BsCalendar4Week,
  BsChatDots,
  BsCart4,
  BsCollectionPlay,
  BsCoin,
  BsShare,
} from "react-icons/bs";

import { useState } from "react";

export default function FeatureGrid() {
  const modules = [
    {
      icon: BsCardChecklist,
      label: "Contact",
    },
    {
      icon: BsCardHeading,
      label: "Blog",
    },
    {
      icon: BsCalendar4Week,
      label: "Bookings",
    },
    {
      icon: BsChatDots,
      label: "Chat",
    },
    {
      icon: BsCart4,
      label: "Store",
    },
    {
      icon: BsCollectionPlay,
      label: "Video",
    },
    {
      icon: BsCoin,
      label: "Currencies",
    },
    {
      icon: BsShare,
      label: "Socials",
    },
  ];

  // State to track the current theme
  const { isDarkMode } = useDarkMode();

  // Determine which analytics image to use based on the theme
  const analyticsImage = isDarkMode ? analyticsDark : analyticsLight;

  return (
    <div className="bg-white dark:bg-olenium-bg pt-24">
      <div className="mx-auto max-w-7xl p-4 md:p-8 md:text-left xl:max-w-7xl justify-start">
        <p className="text-base font-semibold tracking-wide text-white uppercase pb-4">
          Our Capabilities
        </p>
        <h2 className="text-3xl tracking-tight text-grey-900 sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 dark:text-white">
          The power of Olenium. <br /> Put to work
        </h2>
        <p className="mt-6 text-lg tracking-tight text-gray-600 dark:text-white xl:max-w-3xl">
        With Olenium, you gain access to a powerful platform designed to elevate your online presence and support your business's growth.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mx-auto max-w-7xl p-4 md:p-8">
        {/* First row */}
        <div class="md:col-span-2">
          <div class="relative isolate overflow-hidden bg-gray-900 px-6 pt-16 rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-10 lg:px-12 lg:pt-0">
            <svg
              viewBox="0 0 1024 1024"
              class="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 lg:translate-y-0"
              aria-hidden="true"
            >
              <circle
                cx="512"
                cy="512"
                r="512"
                fill="url(#759c1415-0410-454c-8f7c-9a820de03641)"
                fill-opacity="0.7"
              />
              <defs>
                <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641">
                  <stop stop-color="#00B4FF" />
                  <stop offset="1" stop-color="#00B4FF" stop-opacity="0" />
                </radialGradient>
              </defs>
            </svg>
            <div class="mx-auto max-w-md text-left lg:mx-0 lg:flex-auto lg:py-32 lg:text-left">
              <svg
                width="113"
                height="25"
                viewBox="0 0 113 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.2257 0.0128366C14.9543 8.61944e-05 16.9306 0.854361 17.3259 1.03287C17.9761 1.32612 19.7612 2.1804 21.4187 4.0037C22.5918 5.30424 23.2165 6.54102 23.497 7.15304C23.701 7.5993 24.5043 9.44811 24.5808 12.0237C24.6573 14.9818 23.7265 17.1621 23.4205 17.8378C23.0125 18.7176 21.9797 20.9107 19.5699 22.6702C18.3331 23.5755 16.8923 24.2258 15.2476 24.6083C11.3204 25.5136 7.66108 24.825 4.47349 22.2495C2.21668 20.4262 0.814137 18.0546 0.253121 15.2113C-0.307895 12.2532 0.21487 9.90712 0.380625 9.2696C0.58463 8.49183 1.06914 6.92354 2.21668 5.25324C3.31321 3.67219 4.47349 2.74141 4.79225 2.49916C5.32777 2.0784 6.70481 1.09662 8.77037 0.49735C9.17838 0.369847 10.4789 0.0128366 12.2257 0.0128366ZM21.8777 12.5209C21.8905 11.1184 21.6355 9.75412 21.0872 8.44083C19.1874 3.83795 14.4953 1.44088 9.58639 2.77967C6.75581 3.54469 4.79225 5.38074 3.58097 8.03282C2.66294 10.0601 2.48443 12.1894 2.84145 14.3697C3.17295 16.3716 4.02723 18.1311 5.42977 19.5974C7.66108 21.9307 10.4407 22.8232 13.6028 22.4152C16.9689 21.9817 19.3659 20.1074 20.8705 17.0856C21.5972 15.6703 21.9032 14.153 21.8777 12.5209Z"
                  fill="url(#paint0_linear_114_1285)"
                />
                <path
                  d="M111.985 24.9141C111.832 24.9141 111.691 24.9269 111.564 24.9141C110.556 24.7611 109.677 23.7921 109.587 22.7721C109.575 22.5681 109.575 22.3641 109.575 22.1601C109.575 19.8905 109.575 17.6337 109.575 15.3641C109.575 14.5608 109.498 13.7703 109.23 13.018C109.103 12.661 108.937 12.304 108.746 11.9725C108.198 11.0545 107.382 10.5445 106.349 10.3405C105.597 10.1875 104.844 10.2002 104.105 10.3787C103.263 10.5827 102.562 11.0035 102.001 11.6537C101.312 12.4443 100.904 13.3623 100.777 14.4078C100.7 15.0963 100.688 15.6319 100.688 15.8104C100.713 16.7921 100.7 19.1637 100.688 22.4916C100.649 22.7466 100.471 23.6008 99.7059 24.2639C99.1321 24.7611 98.5201 24.9141 98.2396 24.9651C98.2141 22.1983 98.2269 20.4005 98.2524 19.2402C98.2779 18.0289 98.2524 16.8176 98.2524 15.6064C98.2524 15.2239 98.2396 14.8286 98.2269 14.4461C98.1886 13.7193 97.9974 13.0435 97.6786 12.3933C97.1048 11.2075 96.1741 10.4807 94.8735 10.2767C94.287 10.1875 93.7005 10.1747 93.114 10.2895C91.8644 10.5317 90.9209 11.2457 90.2579 12.3168C89.5566 13.4388 89.4546 14.5226 89.4164 15.0326C89.3909 15.3386 89.3909 15.5936 89.4036 15.7721C89.4036 18.0162 89.3909 20.2602 89.3909 22.5043C89.3909 22.6573 89.3781 23.5881 88.6258 24.3021C87.9246 24.9651 87.0958 24.9779 86.9045 24.9779C86.9045 19.2785 86.9045 13.5791 86.9045 7.87964C87.7333 7.87964 88.5493 7.87964 89.3781 7.87964C89.3781 8.89967 89.3781 9.93245 89.3781 10.9525C89.6459 10.5955 90.0411 10.111 90.5767 9.61369C91.0229 9.20568 91.4309 8.82317 92.0684 8.50441C93.012 8.03264 94.0575 7.86689 95.1923 7.95614C95.6768 7.99439 96.1613 8.07089 96.6331 8.21115C97.9336 8.61916 98.9281 9.42243 99.6549 10.57C99.7697 10.7612 99.8844 10.9525 100.012 11.182C100.547 10.4042 101.121 9.8687 101.542 9.52444C101.937 9.19293 102.498 8.74666 103.34 8.41515C103.939 8.1729 104.577 8.03264 105.252 7.99439C106.068 7.94339 106.884 7.95614 107.688 8.16015C109.358 8.56816 110.556 9.57544 111.321 11.1055C111.768 11.998 111.972 12.9415 112.048 13.9361C112.074 14.2421 112.061 14.5481 112.061 14.8541C112.061 17.9779 112.061 21.1018 112.061 24.2129C112.036 24.4551 112.074 24.6719 111.985 24.9141Z"
                  fill="url(#paint1_linear_114_1285)"
                />
                <path
                  d="M47.0086 17.1492C44.4586 17.1619 41.8957 17.1747 39.3457 17.1874C39.2182 17.1874 38.3894 17.2002 37.7646 16.5372C37.2164 15.9634 37.1909 15.2749 37.1909 15.1219C39.6262 15.1219 42.0615 15.1219 44.4968 15.1219C44.4841 14.7139 44.4331 14.1018 44.1781 13.4006C43.8593 12.508 43.3875 11.9343 43.2218 11.7558C42.6098 11.0418 41.9595 10.6975 41.7555 10.5827C41.628 10.519 41.0415 10.2257 40.2255 10.0982C38.4531 9.81772 37.0251 10.519 36.8211 10.6337C34.73 11.692 34.0798 13.7066 33.9395 14.1018C33.6335 15.0199 33.6335 15.8231 33.6335 16.3459C33.6335 16.9834 33.6335 18.0672 34.0925 19.1637C34.9213 21.1273 36.9486 22.5043 38.9377 22.7338C40.1362 22.8741 41.0925 22.5808 41.2965 22.5298C41.9722 22.3258 42.5715 22.0071 43.0815 21.5863C43.6043 21.14 43.9613 20.5918 44.0888 20.3878C44.1908 20.2348 44.2673 20.0945 44.3183 20.0053C44.6498 20.1455 44.9941 20.2985 45.3383 20.4643C45.6826 20.63 46.0141 20.7958 46.3329 20.9615C46.2436 21.1528 46.1799 21.3058 46.1034 21.4461C45.2108 22.9761 43.8848 23.9961 42.2145 24.5316C37.3949 26.0617 32.486 23.3969 31.3767 18.3987C30.7392 15.5299 31.3639 12.8778 33.3148 10.621C34.5643 9.16745 36.1453 8.21118 38.0706 7.96892C40.2 7.70116 42.2273 8.01992 43.9868 9.35871C45.1088 10.213 45.8611 11.335 46.3456 12.6356C46.9831 14.3696 46.9831 16.2184 46.9704 16.9069C47.0214 17.0089 47.0214 17.0982 47.0086 17.1492Z"
                  fill="url(#paint2_linear_114_1285)"
                />
                <path
                  d="M84.7882 7.87964C84.7882 13.5791 84.7882 19.2785 84.7882 24.9779C83.9722 24.9779 83.1562 24.9779 82.3529 24.9779C82.3529 23.9323 82.3529 22.8741 82.3529 21.8285C82.1234 22.211 81.7664 22.6956 81.2564 23.1801C80.6061 23.8048 80.0068 24.1364 79.8538 24.2256C78.7063 24.8504 77.6608 24.9396 77.189 24.9779C76.067 25.0671 75.1872 24.8631 74.8174 24.7611C74.3074 24.6209 73.4786 24.3914 72.6371 23.7283C71.8976 23.1418 71.3238 22.3513 70.9158 21.3823C70.495 20.3877 70.3548 19.3422 70.3548 18.2712C70.342 15.8231 70.3548 13.375 70.3548 10.927C70.3548 9.72844 70.3548 8.47891 70.3548 8.47891C70.3548 8.2239 70.3548 8.01989 70.3548 7.89239C70.5588 7.91789 70.8648 7.95614 71.2091 8.09639C71.4641 8.1984 72.0123 8.4279 72.3948 9.00167C72.6116 9.32043 72.7519 9.70294 72.7774 10.162C72.8029 10.3915 72.7901 10.6082 72.7901 10.8377C72.7901 13.0818 72.7901 15.3259 72.7901 17.5699C72.7901 18.3222 72.8666 19.0745 73.1089 19.8012C73.6954 21.5353 74.9449 22.5936 76.9085 22.7338C77.5587 22.7848 78.209 22.7466 78.8465 22.5426C79.5988 22.3003 80.2236 21.9433 80.7336 21.4715C81.7409 20.528 82.0469 19.4187 82.1744 18.947C82.3401 18.2967 82.3656 17.7357 82.3529 17.3532C82.3529 14.9688 82.3529 12.5845 82.3401 10.1875C82.3656 9.9452 82.4676 9.32043 82.9521 8.75941C83.6534 7.95614 84.6097 7.89239 84.7882 7.87964Z"
                  fill="url(#paint3_linear_114_1285)"
                />
                <path
                  d="M63.6735 24.978C63.4312 24.9653 62.8192 24.927 62.2327 24.4935C61.7354 24.1365 61.5186 23.6902 61.4676 23.5755C61.2509 23.1037 61.2381 22.6829 61.2381 22.4917C61.2126 16.703 61.2381 15.6447 61.2381 15.6447C61.2381 15.4025 61.2381 14.8415 61.1361 14.1275C61.0724 13.7067 60.9704 13.2859 60.8174 12.8907C60.1926 11.2841 58.9941 10.4298 57.2983 10.2641C56.7755 10.2131 56.2272 10.2131 55.7172 10.3023C54.9395 10.4426 54.2892 10.7231 53.7409 11.1184C52.5424 11.9854 52.1089 13.1967 51.9559 13.6684C51.7009 14.4335 51.6626 15.0965 51.6754 15.53C51.6881 18.8323 51.6754 21.3442 51.6626 22.5427C51.6626 22.7722 51.6626 23.2695 51.3694 23.754C51.0251 24.315 50.4641 24.5955 50.2601 24.6975C49.8521 24.9015 49.4696 24.9653 49.2273 24.9908C49.2273 24.876 49.2273 22.5554 49.2273 22.4534C49.24 15.5172 49.2528 12.8269 49.2273 9.11656C49.2273 8.55554 49.2273 8.10928 49.2273 7.90527C50.0433 7.90527 50.8593 7.90527 51.6881 7.90527C51.6881 8.96355 51.6881 10.0218 51.6881 11.0801C51.9431 10.6976 52.3384 10.1748 52.9122 9.66482C54.1744 8.54279 55.4622 8.18578 55.7045 8.12203C56.0232 8.03278 57.0433 7.79052 58.3693 7.98178C58.9813 8.07103 60.0906 8.23678 61.1999 9.05281C62.2837 9.84333 62.7682 10.8251 62.9722 11.2204C63.4312 12.1766 63.6097 13.1967 63.6735 14.2422C63.699 14.612 63.6862 14.8797 63.6862 14.9817C63.6607 16.2823 63.6735 19.4189 63.6862 24.2767C63.6735 24.4935 63.6735 24.7358 63.6735 24.978Z"
                  fill="url(#paint4_linear_114_1285)"
                />
                <path
                  d="M26.5828 0C27.4115 0 28.2403 0 29.0691 0C29.0818 8.32599 29.0818 16.652 29.0946 24.978C28.2658 24.978 27.437 24.978 26.5955 24.978C26.5955 19.9926 26.5955 15.3897 26.5955 15.0072C26.5955 11.9726 26.5828 3.03459 26.5828 0Z"
                  fill="url(#paint5_linear_114_1285)"
                />
                <path
                  d="M65.7774 24.9779C65.7774 19.2785 65.7774 13.5791 65.7646 7.87964C66.5807 7.87964 67.3967 7.87964 68.2255 7.87964C68.2255 12.7503 68.2382 17.6209 68.2382 22.5043C68.2382 22.7083 68.2 23.4733 67.6135 24.1491C66.8994 24.9396 65.9432 24.9779 65.7774 24.9779Z"
                  fill="url(#paint6_linear_114_1285)"
                />
                <path
                  d="M66.9503 4.1311C66.0833 4.1821 65.1143 3.34058 65.1653 2.29505C65.2035 1.47902 65.8665 0.471744 66.9503 0.484495C68.2763 0.497245 68.8884 1.56828 68.8629 2.42255C68.8374 3.34058 67.9576 4.22035 66.9503 4.1311Z"
                  fill="url(#paint7_linear_114_1285)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_114_1285"
                    x1="12.2926"
                    y1="0.0126953"
                    x2="12.2926"
                    y2="24.9875"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#389EFB" />
                    <stop offset="1" stop-color="#82B9EB" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_114_1285"
                    x1="99.4844"
                    y1="7.87964"
                    x2="99.4844"
                    y2="24.9779"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#389EFB" />
                    <stop offset="1" stop-color="#82B9EB" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_114_1285"
                    x1="39.076"
                    y1="7.88184"
                    x2="39.076"
                    y2="24.9622"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#389EFB" />
                    <stop offset="1" stop-color="#82B9EB" />
                  </linearGradient>
                  <linearGradient
                    id="paint3_linear_114_1285"
                    x1="77.5687"
                    y1="7.87964"
                    x2="77.5687"
                    y2="24.9999"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#389EFB" />
                    <stop offset="1" stop-color="#82B9EB" />
                  </linearGradient>
                  <linearGradient
                    id="paint4_linear_114_1285"
                    x1="56.4583"
                    y1="7.90527"
                    x2="56.4583"
                    y2="24.9908"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#389EFB" />
                    <stop offset="1" stop-color="#82B9EB" />
                  </linearGradient>
                  <linearGradient
                    id="paint5_linear_114_1285"
                    x1="27.8387"
                    y1="0"
                    x2="27.8387"
                    y2="24.978"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#389EFB" />
                    <stop offset="1" stop-color="#82B9EB" />
                  </linearGradient>
                  <linearGradient
                    id="paint6_linear_114_1285"
                    x1="67.0014"
                    y1="7.87964"
                    x2="67.0014"
                    y2="24.9779"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#389EFB" />
                    <stop offset="1" stop-color="#82B9EB" />
                  </linearGradient>
                  <linearGradient
                    id="paint7_linear_114_1285"
                    x1="67.0135"
                    y1="0.484375"
                    x2="67.0135"
                    y2="4.13736"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#389EFB" />
                    <stop offset="1" stop-color="#82B9EB" />
                  </linearGradient>
                </defs>
              </svg>

              <h2 class="text-3xl font-bold tracking-tight text-white sm:text-3xl mt-6">
                Designed and developed to be beautiful and easy to use
              </h2>
              <p class="mt-6 text-lg leading-8 text-gray-300">
                Our main service is web design, including content management systems, ecommerce, responsive websites and web development. We also offer web hosting, domain registration and email services.
              </p>
            </div>
            <div class="relative mt-16 h-80 lg:mt-8">
              {/* add border radius to top left corner */}
              <img
                class="absolute left-0 top-0 w-[57rem] max-w-none rounded-l-3xl"
                src={cms}
                alt="App screenshot"
                width="1824"
                height="1080"
              />
            </div>
          </div>
        </div>

        <div className="md:col-span-1 bg-gradient-to-r from-blue-400 to-blue-600 p-8 text-white rounded-3xl p-4 md:p-12">
          <div className="justify-start md:text-left">
            <h3 className="text-2xl tracking-tight sm:text-2xl md:text-2xl lg:text-3xl font-extrabold text-white">
              Full GDPR Compliance
            </h3>
            <p className="my-6 text-lg tracking-tight text-white xl:max-w-3xl">
              Run a fully complient cookie system that can link with Google
              Tags. We also offer a cookie consent banner that can be customised
              to your brand.
            </p>
            <img
              src={cookies}
              alt="cookies"
              className="w-full h-full mx-auto object-cover rounded-2xl mt-16"
            />
          </div>
        </div>

        {/* Second row */}
        <div className="md:col-span-3 bg-white dark:bg-black p-8 text-white rounded-3xl p-4 md:p-12 border-4 ">
          <div className="justify-start md:text-left">
            <p className="text-base font-semibold tracking-wide text-black dark:text-white uppercase pb-4">
              Business Intelligence
            </p>
            <p className="mt-6 text-lg tracking-tight text-black dark:text-white xl:max-w-3xl">
              We leverage advanced business intelligence tools to provide
              actionable insights, enhancing decision-making and performance.
            </p>
            <div className="justify-start md:text-left">
              <img
                src={analyticsImage}
                alt="analytics"
                className="w-full h-full mx-auto object-cover mt-8"
              />
            </div>
          </div>
        </div>

        {/* Third row */}
        <div className="md:col-span-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
            <div className="col-span-1 bg-gradient-to-r from-[#5B8EF1] to-[#0085FF] p-8 text-white rounded-3xl p-4 md:p-12">
              <div className="justify-start md:text-left">
                <p className="text-base font-semibold tracking-wide text-white uppercase pb-4">
                  A massive collection of modules
                </p>
                <p className="mt-2 text-lg tracking-tight text-white xl:max-w-3xl">
                  Our platform offers a comprehensive collection of modules,
                  including chat, booking, contact, and social features, to
                  streamline your online presence.
                </p>
              </div>
              <div className="flex flex-wrap justify-center grid grid-cols-2 gap-4 mt-8 md:mt-12 md:grid-cols-4">
                {modules.map((module, index) => {
                  const Icon = module.icon;
                  return (
                    <div className="flex flex-col items-center" key={index}>
                      <div
                        key={index}
                        className="flex items-center justify-center h-16 w-16 bg-white/30 rounded-full"
                      >
                        <Icon className="h-8 w-8 text-white" />
                      </div>
                      <p className="text-white text-center mt-2 text-sm">
                        {module.label}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="col-span-1 dark:bg-black text-white rounded-3xl px-4 md:px-12 pt-4 md:pt-12 border-4 border-[#0085FF]">
              <div className="justify-start md:text-left">
                <h3 className="text-2xl tracking-tight text-grey-900 sm:text-2xl md:text-2xl lg:text-3xl font-extrabold text-gray-900 dark:text-white text-center my-8">
                  Grow your website as you grow
                </h3>
                <img
                  src={sitemap}
                  alt="sitemap"
                  className="w-full h-full mx-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Fourth row */}
        <div className="md:col-span-3">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
            <div className="col-span-1 bg-[#F5F5F5] dark:bg-[#181818] p-8 text-white rounded-3xl p-4 md:p-12">
              <div className="flex flex-col justify-center items-center h-full">
                <div className="flex items-center justify-center w-full h-24 my-24">
                  <div className="flex items-center justify-center h-52 w-52 bg-[#F5F5F5] rounded-full dark:bg-[#181818] border-4 border-[#232323] dark:border-white">
                    <BsCalendar2Week className="h-28 w-28 text-[#232323] dark:text-white" />
                  </div>
                </div>
                <h3 className="text-2xl tracking-tight text-grey-900 sm:text-2xl md:text-2xl lg:text-3xl font-extrabold text-gray-900 dark:text-white text-center mt-5">
                  We aim to get your site live in 14 days
                </h3>
              </div>
            </div>
            {/* Can you add a 45 degree gradient to the background of this div? */}
            <div className="col-span-1 bg-gradient-to-r from-[#F5F5F5] to-[#F5F5F5] dark:from-[#181818] dark:to-[#181818] p-8 text-white rounded-3xl p-4 md:p-12">
              <div className="flex flex-col justify-center items-center h-full">
                <img src={freelance} alt="freelance" className="mx-auto mb-6" />
                <h3 className="text-2xl tracking-tight text-grey-900 sm:text-2xl md:text-2xl lg:text-3xl font-extrabold text-gray-900 dark:text-white text-center">
                  Access to our freelance network
                </h3>
              </div>
            </div>
            <div className="col-span-1 bg-[#F5F5F5] dark:bg-[#181818] p-8 text-white rounded-3xl p-4 md:p-12">
              <div className="flex flex-col justify-center items-center h-full">
                <img
                  src={seo}
                  alt="seo"
                  className="w-full h-full mx-auto object-cover p-8 mb-4"
                />
                <h3 className="text-2xl tracking-tight sm:text-2xl md:text-2xl lg:text-3xl font-extrabold text-center text-gray-900 dark:text-white">
                  Best in class Lighthouse SEO scores
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
